export default "__VITE_ASSET__f74b1e30__"